(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth > 1436) {
      const callback = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            for (const node of mutation.addedNodes) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                let snizeElement = null;

                // Check if the added node is or contains the .snize-ac-results element
                if (node.matches('.snize-ac-results')) {
                  snizeElement = node;
                } else {
                  snizeElement = node.querySelector('.snize-ac-results');
                }

                if (snizeElement) {
                  // Move the .snize-ac-results element into #snize-results-header-v2
                  const targetDiv = document.getElementById('snize-results-header-v2');
                  if (targetDiv) {
                    targetDiv.appendChild(snizeElement);
                  } else {
                    console.error('#snize-results-header-v2 not found in DOM');
                  }

                  // Disconnect the observer if you no longer need it
                  observer.disconnect();
                  break;
                }
              }
            }
          }
        }
      };

      const observer = new MutationObserver(callback);

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
